import React, { useState } from 'react';
import { ChevronDown, LogIn } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import UserProfile from './UserProfile';
import AuthModal from './AuthModal';

const Header = () => {
  const { user, isAuthenticated, signout } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleAuthSuccess = (userData) => {
    setShowAuthModal(false);
  };

  const handleSignout = () => {
    signout();
  };

  return (
    <>
      <div className="ml-64 bg-white border-b border-gray-200 p-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-4">
            {isAuthenticated && user ? (
              <>
                <UserProfile user={user} onSignout={handleSignout} />
                <div className="flex items-center space-x-2">
                  <span className="text-gray-600">Organization Dashboard</span>
                  <ChevronDown size={16} className="text-gray-500" />
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-2">
                <span className="text-gray-600">TCF Studio</span>
              </div>
            )}
          </div>
          <div className="flex items-center space-x-3">
            {isAuthenticated && user ? null : (
              <button
                onClick={() => setShowAuthModal(true)}
                className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
              >
                <LogIn size={16} />
                <span>Sign In</span>
              </button>
            )}
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onAuthSuccess={handleAuthSuccess}
      />
    </>
  );
};

export default Header;